require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-morse-torch-app-final.json") })
        }
      }, "path---blog-morse-torch-app-final");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-morse-torch-app-final!./.cache/json/blog-morse-torch-app-final.json
// module id = 971
// module chunks = 231608221292675